import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
declare var $: any;
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable({
  providedIn: 'root'
})

export class DataService {

  //Service variable declaration
  userInfo: any;
  contentInfo: any;
  staticContent: boolean;
  lastPage: string = '';
  pageLimit: string = '100';
  scheduleDetails: any;
  scheduleEdit: boolean;
  groupInfo: any;
  playlistDetails: any;
  playlistEdit: boolean;
  loginError: boolean = false;

  //Server access ip and port
  public ip1: string = 'http://192.168.86.35';
  public ip2: string = 'https://localhost';
  public ip3: string = 'http://103.99.149.26';
  public ip4: string = 'http://192.168.86.247';
  public ip5: string = "http://35.154.148.94";
  public ip6: string = "http://35.154.148.94:3150"
  public port: string = ':3015';
  public port1: string = ':3150';
  public ipaddr: string = this.ip6;
  // public ipaddr: string = "https://api.kindlesign.com";

  /**
   * @param http 
   * @param router 
   * @param _location 
   */
  constructor(private _router: Router, private _location: Location) {
    localStorage.setItem('ip', '13.235.45.91');
    localStorage.setItem('port', '3050');
  }

  // loadLastPage() {
  //   var x = localStorage.getItem('lastpage');
  //   this._router.navigate([x]);
  // }

  refreshloadLastPage() {
    var x = localStorage.getItem('lastpage');
    if (this.lastPage == null || this.lastPage == undefined || this.lastPage == '') {
      this._location.back();
    }
  }

  setLastPage(url, error) {
    this.lastPage = url.split('/').pop();
    localStorage.setItem('lastpage', this.lastPage);
    localStorage.setItem('error', JSON.stringify(error));
    this._router.navigate(['/auth/error']);
  }

  setEditUser(x) {
    this.userInfo = x;
  }

  setGroupInfo(info) {
    this.groupInfo = info;
  }

  getGroupInfo() {
    return this.groupInfo
  }

  getUserInfo() {
    if (this.userInfo != null && this.userInfo != undefined && this.userInfo != '') {
      return this.userInfo;
    } else {
      this._router.navigate(['userlist'])
    }
  }

  setContentInfo(info, staticInfo) {
    this.staticContent = staticInfo;
    this.contentInfo = info;
  }

  getContentInfo() {
    return this.contentInfo;
  }

  setEditSchedule(editInfo) {
    this.scheduleDetails = editInfo;
    this.scheduleEdit = true;
  }

  getEditSchedule() {
    if (this.scheduleDetails != null && this.scheduleDetails != undefined && this.scheduleDetails != '' && typeof this.scheduleDetails == 'object') {
      return this.scheduleDetails;
    } else {
      this._router.navigate(['schedulelist']);
    }
  }

  setEditPlaylist(editInfo) {
    this.playlistDetails = editInfo;
    this.playlistEdit = true;
  }

  getEditPlaylist() {
    if (this.playlistDetails != null && this.playlistDetails != undefined && this.playlistDetails != '' && typeof this.playlistDetails == 'object') {
      return this.playlistDetails;
    } else {
      this._router.navigate(['playlist']);
    }
  }

  checkUserType() {
    let user = JSON.parse(localStorage.getItem('cred'));
    if (this.variableCheckNotNullIsObject(user)) {
      return true;
    } else {
      return false;
    }

    // if (user.user.role == 'admin') {
    //   return true;
    // } else {
    //   return false;
    // }
  }

  variableCheckNotNull(variable: any) {
    if (variable != null && variable != '' && variable != undefined) {
      return true;
    } else {
      return false;
    }
  }

  variableCheckNotNullIsObject(variable: any) {
    if (variable != null && variable != '' && variable != undefined && typeof variable == 'object') {
      return true;
    } else {
      return false;
    }
  }

  showNotificationService(text, type) {
    // var type = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];
    // var color = Math.floor((Math.random() * 6) + 1);
    $.notify({
      icon: "notifications",
      message: text
    }, {
      type: type,
      timer: 2000,
      showProgressbar: false,
      animate: {
        enter: 'animated fadeInDown',
        exit: 'animated fadeOutUp'
      },
      placement: {
        from: 'top',
        align: 'right'
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
      // icon_type: 'class',
      // template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
      //   '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
      //   '<span data-notify="icon"></span> ' +
      //   '<span data-notify="title">{1}</span> ' +
      //   '<span data-notify="message">{2}</span>' +
      //   '<div class="progress" data-notify="progressbar">' +
      //   '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
      //   '</div>' +
      //   '<a href="{3}" target="{4}" data-notify="url"></a>' +
      //   '</div>'
    });
  }
}
